"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Type definitions for React-Loading-Overlay 1.0
// Project: https://github.com/derrickpelletier/react-loading-overlay
// Definitions by: DefinitelyTyped <https://github.com/DefinitelyTyped>
// Definitions: https://github.com/DefinitelyTyped/DefinitelyTyped
const css_1 = require("@emotion/css");
const react_transition_group_1 = require("react-transition-group");
const react_1 = __importStar(require("react"));
const Spinner_1 = __importDefault(require("./components/Spinner"));
const styles_1 = __importDefault(require("./styles"));
class LoadingOverlay extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.wrapper = (0, react_1.createRef)();
        this.nodeRef = (0, react_1.createRef)();
        /**
         * Return an emotion css object for a given element key
         * If a custom style was provided via props, run it with
         * the base css obj.
         */
        this.getStyles = (key, providedState) => {
            const base = styles_1.default[key](providedState, this.props);
            const custom = this.props.styles ? this.props.styles[key] : undefined;
            if (!custom) {
                return base;
            }
            ;
            return typeof custom === "function" ? custom(base, this.props) : custom;
        };
        /**
         * Convenience cx wrapper to add prefix classes to each of the child
         * elements for styling purposes.
         */
        this.cx = (names, ...args) => {
            const arr = Array.isArray(names) ? names : [names];
            return (0, css_1.cx)(...arr.map((name) => {
                var _a;
                return name
                    ? `${(_a = this.props.classNamePrefix) !== null && _a !== void 0 ? _a : "_loading_overlay_"}${name}`
                    : "";
            }), ...args);
        };
        this.state = { overflowCSS: {} };
    }
    componentDidMount() {
        const wrapperStyle = window.getComputedStyle(this.wrapper.current);
        const overflowCSS = ["overflow", "overflowX", "overflowY"].reduce((m, i) => {
            if (wrapperStyle[i] !== "visible")
                m[i] = "hidden";
            return m;
        }, {});
        this.setState({ overflowCSS });
    }
    componentDidUpdate(prevProps) {
        const { active } = this.props;
        if (active)
            this.wrapper.current.scrollTop = 0;
    }
    render() {
        const { children, className, onClick, active, fadeSpeed = 500, spinner, text, } = this.props;
        return (react_1.default.createElement("div", { "data-testid": "wrapper", ref: this.wrapper, className: this.cx(["wrapper", active && "wrapper--active"], (0, css_1.css)(this.getStyles("wrapper", active ? this.state.overflowCSS : {})), className) },
            react_1.default.createElement(react_transition_group_1.CSSTransition, { in: active, classNames: "_loading-overlay-transition", timeout: fadeSpeed, unmountOnExit: true, ref: this.nodeRef, addEndListener: () => { } }, (state) => (react_1.default.createElement("div", { "data-testid": "overlay", className: this.cx("overlay", (0, css_1.css)(this.getStyles("overlay", state))), onClick: onClick },
                react_1.default.createElement("div", { className: this.cx("content", (0, css_1.css)(this.getStyles("content"))), ref: this.nodeRef },
                    spinner &&
                        (typeof spinner === "boolean" ? (react_1.default.createElement(Spinner_1.default, { cx: this.cx, getStyles: this.getStyles })) : (spinner)),
                    text)))),
            children));
    }
}
exports.default = LoadingOverlay;
//# sourceMappingURL=index.js.map